import { PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { coverageGroupData } from '../data';
import { CoverageGroupIdEnum, CoverageGroupLayoutEnum, CoverageGroupTypeEnum } from '../enums';
import {
    CoverageControlConfigGroupInterface,
    CoverageControlConfigInputInterface,
    CoverageGroupDataGroupInterface,
} from '../interfaces';
import { CoverageInput } from './coverage-input.class';

/**
 * Creates an object which represents a group of coverages; for example vehicle base coverages.
 * Configurations are from the config object, prices from the backend and content from the coverage data object.
 */
export abstract class CoverageGroupAbstract {
    productId: PolicyProductIdEnum;
    id: CoverageGroupIdEnum;
    type: CoverageGroupTypeEnum;
    inputs: CoverageInput[] = [];
    required: boolean = false;
    single?: boolean = false;
    hidden?: boolean = false;
    layout?: CoverageGroupLayoutEnum;
    hasBorder?: boolean = false;
    data?: CoverageGroupDataGroupInterface;

    constructor(
        type: CoverageGroupTypeEnum,
        group: CoverageControlConfigGroupInterface,
        purchasedProduct: PurchasedProductInterface,
    ) {
        this.productId = purchasedProduct.productId;
        this.id = group.id;
        this.type = type;
        this.single = group.options.single || false;
        this.hidden = group.options.hidden || false;
        this.required = group.options.required || false;
        this.layout = group.options.layout || null;
        this.hasBorder = group.options.hasBorder || false;
        this.data = this.getCoverageGroupData(group.id, purchasedProduct.productId);

        group.inputs.forEach((input) => this.addInput(input, purchasedProduct));
    }

    private addInput(
        input: CoverageControlConfigInputInterface,
        purchasedProduct: PurchasedProductInterface,
    ): void {
        const coverageInput = new CoverageInput(input, purchasedProduct);

        this.inputs.push(coverageInput);
    }

    private getCoverageGroupData(
        groupId: CoverageGroupIdEnum,
        productId: PolicyProductIdEnum,
    ): CoverageGroupDataGroupInterface {
        const foundCoverageGroupData = coverageGroupData
            .find((groupData) => groupData.productId === productId);

        if (!foundCoverageGroupData) {
            return;
        }

        return foundCoverageGroupData.groups
            .find((_group) => _group.groupId === groupId);
    }
}
